module.exports = __webpack_public_path__ + "static/media/bpls-logo-short.2657df41.svg";